module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dictionary":{"id":"ID","code":"Code","name":"Name","title":"Dictionary","title0":"Dictionaries","tabs":{"items":"Items","attributes":"Attributes"}}},"ru":{"dictionary":{"id":"ID","code":"Код","name":"Наименование","title":"Справочник","title0":"Справочники","tabs":{"items":"Элементы справочника","attributes":"Атрибуты"}}}}')
  delete Component.options._Ctor
}
